import { atom } from 'jotai'
import { ChainInfo } from '../../../api/v1/chains'

export const showNetSelectPopup = atom<boolean>(false)
export const selectedNetwork = atom<ChainInfo | undefined>(undefined)
